import { BrokenUrlResultConstants } from "../constants/BrokenUrlResultConstants";
import { BrokenUrlResultServices } from "../services/BrokenUrlResultServices";

export const BrokenUrlResultActions = {
  fetchGetList,
  fetchGetListFilter,
  setPageListFilter,
  fetchApprove,
  setSelectedList,
  setOriginalList,
};

function fetchGetList(isForViewLog,page) {
  return (dispatch) => {
    dispatch(request());
    BrokenUrlResultServices.getList(isForViewLog).then(
      (data) => dispatch(success(data,page)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_PENDING,
    };
  }

  function success(data,page) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_GET_LIST_SUCCESS,
      payload: data,
      page:page
    };
  }

  function failure(error) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_ERROR,
      error: error,
    };
  }
}

function fetchGetListFilter(list,page) {
  return (dispatch) => {
    dispatch(request());
    return dispatch(success(list,page));
  };

  function request() {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_PENDING,
    };
  }

  function success(list) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_GET_LIST_SUCCESS,
      payload: list,
      page:page
    };
  }
}

function setPageListFilter(page) {
  return (dispatch) => {
    dispatch(request());
    return dispatch(success(page));
  };

  function request() {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_PENDING,
    };
  }

  function success(page) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_SET_PAGE,
      page:page
    };
  }
}

function fetchApprove(idfreeprofilesurl, resultList, originalList) {
  return (dispatch) => {
    dispatch(request());
    BrokenUrlResultServices.approve(idfreeprofilesurl).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    ).then(() => {
      resultList.data = resultList.data.filter(item => item.IdFreeprofilesUrl !== idfreeprofilesurl);
      if(originalList.length > 0 )
      {
        originalList = originalList.filter(item => item.IdFreeprofilesUrl !== idfreeprofilesurl);
      }
      dispatch(setSelectedList(resultList, originalList));;
    });
  };

  function request() {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_PENDING,
    };
  }

  function success(data) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_SET_APPROVE
    };
  }

  function failure(error) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_ERROR,
      error: error,
    };
  }
}

function setSelectedList(selectedList, originalList) {
  return (dispatch) => {
    dispatch(request());
    dispatch(success(selectedList, originalList));
  };
  function request() {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_PENDING,
    };
  }
  function success(selectedList, originalList) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_SET_SELECTED_LIST,
      selectedList: selectedList,
      originalList: originalList,
    };
  }
}


function setOriginalList(originalList) {
  return (dispatch) => {
    dispatch(request());
    dispatch(success(originalList));
  };
  function request() {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_PENDING,
    };
  }
  function success(originalList) {
    return {
      type: BrokenUrlResultConstants.FETCH_BROKEN_URL_SET_ORIGINAL_LIST,
      originalList: originalList,
    };
  }
}